<template>
    <div v-resize:debounce="onResize">
        <svg></svg>
    </div>
</template>

<script>
import resize from 'vue-resize-directive';
import { ChartDataHelper } from '@/components/charts/ChartDataHelper';
import { ChartInteractions } from '@/components/charts/common/ChartInteractions';
import { ChartRenderer } from '@/components/charts/common/ChartRenderer';
import { ChartCanvas } from '@/components/charts/common/ChartCanvas';
import { LinearBubbleModule } from '@/components/charts/LinearBubble/LinearBubbleModule';
import { SwotModule } from '@/components/charts/Swot/SwotModule';
import { OrdinalLineModule } from '@/components/charts/OrdinalLine/OrdinalLineModule';
import { TimeLineModule } from '@/components/charts/TimeLine/TimeLineModule';
import { GroupedBarModule } from '@/components/charts/GroupedBar/GroupedBarModule';

const moduleList = [
    LinearBubbleModule, OrdinalLineModule, TimeLineModule, GroupedBarModule, SwotModule
];

const d3 = Object.assign({},
    require('d3-selection'),
    require('d3-axis'));

export default {
    props: {
        chartData: {
            type: Object,
            required: true
        }
    },
    directives: {
        resize
    },
    data () {
        return {
            modules: {},
            interact: {}
        };
    },
    methods: {
        renderChart (mode) {
            this.modules[this.chartData.chartType].render(mode);
        },
        onResize () {
            const e = this.$el;
            this.canvas.resize(e.clientWidth, e.clientHeight);
            this.renderChart('update');
        }
    },
    mounted () {
        const e = this.$el;
        this.canvas = new ChartCanvas(d3.select(e.getElementsByTagName('svg')[0]));
        this.canvas.resize(e.clientWidth, e.clientHeight);

        const chartDataHelper = new ChartDataHelper(this.chartData);

        const chartRenderer = new ChartRenderer({
            canvas: this.canvas,
            chartDataHelper
        });

        this.interact = new ChartInteractions(this, chartDataHelper);

        const di = {
            canvas: this.canvas,
            chartDataHelper,
            chartRenderer,
            chartInteractions: this.interact
        };
        for (const Module of moduleList) {
            this.modules[Module.type] = new Module(di);
        }
        this.renderChart('init');
    },
    watch: {
        chartData: {
            handler: function (val, oldVal) {
                this.renderChart('update');
            },
            deep: true
        }
    }
};
</script>

<style lang="scss">
    svg {
        width: 100%;
        height: 100%;

        .annotation-group {
            .label {
                .annotation-note-title {
                    font-size: 0.8em;
                }

                .annotation-note-label {
                    font-size: 0.7em;
                }
            }
        }
    }
</style>
